module.exports = __webpack_public_path__ + "img/vol06_character_thumb06.db11a730.png";